import React, {useState} from "react";
import { Card, Row, Col, InputNumber, Typography, Button, message } from 'antd';

const { Text } = Typography;

const BundledLimitAssignment = ({ childLimit, onSave, stageId, userGroup }) => {
    const [localLimit, setLocalLimit] = useState(childLimit || 0);
    const onChangeChildLimitFn = (val) =>{
        
        if (val === null) {
            setLocalLimit(null);
            return;
        }
        setLocalLimit(val);
    }
    return (
        <Card title="Bundled Limit Assignment" bordered={false}
            extra={
                [
                    <a
                        className="d-flex align-items-center"
                        key={"icon"}
                        disabled={!(
                            [7, 8].includes(stageId) &&
                            userGroup?.some(el => [7, 8].includes(el?.id))
                        )}
                        onClick={() => onSave(localLimit)}
                    >
                        Update
                    </a>
                ]

            }
        >
            <Row gutter={16} align="middle">
                <Col span={8}>
                    <Text strong>Child Case Limit(% of Parent Sanctioned Limit)</Text>
                    <InputNumber
                        min={0}
                        max={100}
                        value={localLimit}
                        disabled={!(
                            [7, 8].includes(stageId) &&
                            userGroup?.some(el => [7, 8].includes(el?.id))
                        )}
                        parser={(val) => {
                            if (!val) return "";
                            let num = Number(val.toString().replace(/[^\d]/g, ""));
                            if (isNaN(num)) return "";
                            return Math.min(100, Math.max(0, num));
                        }}
                        formatter={(val) => (val === null || val === undefined ? "" : String(val))}
                        onChange={onChangeChildLimitFn}
                        style={{ width: '100%' }}
                        placeholder="Enter limit"
                    />
                </Col>
            </Row>
        </Card>
    );
};

export default BundledLimitAssignment;
